module.exports = __webpack_public_path__ + "img/CV.3fc9df08.jpg";